<script>
    export let title;
</script>

<style>
	.container {
        width: 100%;
        padding: 3px 15px;
        font-weight: 700;
        font-size: 18px;
        text-transform: uppercase;
        margin-top: 30px;
	}
</style>

<div class="container">
    {title}
</div>
